import {useEffect, useMemo, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {toastService} from "../../../libraries/toast";
import {useUiContext} from "../../../UIProvider";
import {nltdevskeletonsModel} from "../../nltdevskeletons/entity/nltdevskeletons/NltdevskeletonsModel";
import {getNltdevskeletonsUseCase} from "../../nltdevskeletons/useCases/getNltdevskeletonsUseCase";
import {getMenstrualCycleUseCase} from "../useCases/getMenstrualCycleUseCase";
import {updateMenstrualCycleUseCase} from "../useCases/updateMenstrualCycleUseCase";

interface ContentRecommendationOption {
    label: string;
    id: number;
}

export const useMenstrualCycleEditing = () => {
    const navigate = useNavigate();
    const type = useParams().type;
    const { t } = useUiContext();

    const contentList = nltdevskeletonsModel.nltdevskeletons?.rows ?? [];

    const [ startContentRecommendations, setStartContentRecommendations ] = useState<ContentRecommendationOption[]>([]);
    const [ currentContentRecommendations, setCurrentContentRecommendations ] = useState<ContentRecommendationOption[]>([]);

    const recommendationContentOptions = useMemo(() =>
        contentList.map(item => ({ label: item.name, id: item.id })),
        [contentList]
    );

    useEffect(() => {
        getNltdevskeletonsUseCase();
        if (type) (async () => {
            const data = await getMenstrualCycleUseCase(type);
            const optionsData = data.map(item => ({ label: item.name, id: item.id }));
            setStartContentRecommendations(optionsData);
            setCurrentContentRecommendations(optionsData);
        })();
    }, []);

    const isOptionChosen = (option: ContentRecommendationOption) => {
        return currentContentRecommendations.findIndex(item => item.id === option?.id) !== -1;
    }

    const handleChange = (_event: any, newValue: ContentRecommendationOption[]) => {
        console.log(newValue.length)
        setCurrentContentRecommendations(newValue);
    };

    const onUpdateMenstrualCycle = async () => {
        if (type) {
            const formattedStartContentRecommendations = startContentRecommendations.map(item => item.id);
            const formattedNewContentRecommendations = currentContentRecommendations.map(item => item.id);

            const response = await updateMenstrualCycleUseCase(
                formattedStartContentRecommendations,
                formattedNewContentRecommendations,
                type
            );
            if (!response?.isError) {
                toastService.onSuccess(t('menstrualCycles.updated'));
                navigate('/dashboard/menstrual-phases');
            }
        }
    }

    return {
        onUpdateMenstrualCycle,
        recommendationContentOptions,
        currentContentRecommendations,
        isOptionChosen,
        handleChange
    }
}